export default {
  prices_seen: 'Prices - Seen',
  update_payment_method_clicked:
    'Payment Failed - Update Payment Method CTA Clicked',
  signup_get_started: 'Signup - Get Started',
};
